import { FormGroup, FormControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { EFormHelper } from '../helper/script/helper';
import { Address } from '../form-control/properties/address-properties/address-properties.component';

export class ValidatorConfigure {
   eForm: FormGroup;
   helper = new EFormHelper();

   constructor() {

   }

   fieldExisting(formControl: FormControl) {
      const value = formControl.value;
      const section = this.helper.getSectionAsFormArray(this.eForm);
      const controlValue = [];
      let existing = -1;
      for (let i = 0; i < section.length; i++) {
         const field = this.helper.getFieldAsFormArray(this.eForm, i);
         for (let j = 0; j < field.length; j++) {
            const fieldValue = this.helper.getFieldSomeValue(this.eForm, 'fieldName', i, j);
            controlValue.push(fieldValue);
            existing = controlValue.findIndex((v, index) => {
               if (index !== controlValue.indexOf(value) && value !== '') {
                  return v === value;
               }
            });
         }
      }
      return existing > -1 ? { existing: true } : null;
   }

   fieldExistingColumn(formControl: FormControl) {
      const value = formControl.value;
      const section = this.helper.getSectionAsFormArray(this.eForm);
      const controlValue = [];
      let existing = -1;
      for (let i = 0; i < section.length; i++) {
         const field = this.helper.getFieldAsFormArray(this.eForm, i);
         for (let j = 0; j < field.length; j++) {
            const fieldTable = this.helper.getFieldTableAsFormArray(this.eForm, i, j);
            if (fieldTable) {
               for (let k = 0; k < fieldTable.length; k++) {
                  const fieldValue = this.helper.getFieldTableSomeValue(this.eForm, 'fieldName', i, j, k);
                  controlValue.push(fieldValue);
                  existing = controlValue.findIndex((v, index) => {
                     if (index !== controlValue.indexOf(value) && value !== '') {
                        return v === value;
                     }
                  });
               }
            }
         }
      }
      return existing > -1 ? { existing: true } : null;
   }

   fieldDecimalMath(formControl: FormGroup) {
      const _decimalPlaceValue = formControl.parent?.value.decimalPlace;
      const _integer = formControl.parent?.value.decimalPlace === 0 || formControl.parent?.value.decimalPlace === '';
      const value = formControl.value.replace(/,/g, '');
      const _regex = new RegExp(`^(\\-?\\d{0,}?\\.?\\d{0,${_decimalPlaceValue}})$`, 'gim');
      const _result = _regex.test(value);
      if (!_result && !_integer && value !== '') {
         return { decimalNotMath: true };
      } else {
         return null;
      }
   }

   fieldMustBeInteger(formControl: FormGroup) {
      const _integer = formControl.parent?.value.decimalPlace === 0 || formControl.parent?.value.decimalPlace === '';
      const value = formControl.value.replace(/,/g, '');
      const _regex = new RegExp(`^\\-?\\d+(\\d)?$`, 'gim');
      const _result = _regex.test(value);

      if (!_result && _integer && value !== '') {
         return { mustBeInteger: true };
      } else {
         return null;
      }
   }

   fieldMustDecimal(formControl: FormGroup) {
      const _decimal = formControl.parent?.value.decimalPlace >= 0 || formControl.parent?.value.decimalPlace === '';
      const value = formControl.value.replace(/,/g, '');
      const _regex = new RegExp(`^\\-?\\d+\\.?\\d*$`, 'gim');
      const _result = _regex.test(value);

      if (!_result && _decimal && value !== '') {
         return { mustBeDecimal: true };
      } else {
         return null;
      }
   }

   fieldMustNotBeDash(formControl: FormControl) {
      const value = formControl.value;
      if (value === '-') {
         return { mustNotBeDash: true };
      } else {
         return null;
      }
   }

   fieldBadRange(formControl: FormControl) {
      const _rangeStart = formControl.parent?.value.rangeStart;
      const _rangeEnd = formControl.parent?.value.rangeEnd;
      const _notUndentified = _rangeEnd !== '' && _rangeStart !== '';
      if (Math.round(_rangeStart?.replace(/,/g, '') * 100) > Math.round(_rangeEnd?.replace(/,/g, '') * 100) && _notUndentified) {
         return { badRangeValue: true };
      } else {
         return null;
      }
   }

   includeValidator(formControl: FormControl) {
      const type = formControl.get('type');
      const add1 = formControl.get(Address.Address1);
      const add2 = formControl.get(Address.Address2);
      let _codition = true;
      const _list = [];
      if (add1 !== null && add2 !== null) {
         _list.push(add1.value.include, add2.value.include);
      }

      if (type !== null) {
         if (type.value === 'local') {
            const province = formControl.get(Address.Province)?.value.include;
            const district = formControl.get(Address.District)?.value.include;
            const subDistrict = formControl.get(Address.SubDistrict)?.value.include;
            const zipCode = formControl.get(Address.ZipCode)?.value.include;
            _list.push(province, district, subDistrict, zipCode);
         } else {
            const city = formControl.get(Address.City)?.value.include;
            const state = formControl.get(Address.State)?.value.include;
            const postal = formControl.get(Address.Postal)?.value.include;
            const country = formControl.get(Address.Country)?.value.include;
            _list.push(city, state, postal, country);
         }

         for (const i in _list) {
            if (_list[i] === true) {
               _codition = false;
               break;
            }
         }

         if (_codition) {
            type.setErrors({ mustBeInclude: true });
         } else {
            type.setErrors(null);
         }
      }
      return;
   }

   valueExisting(formControl: FormControl) {
      const _j = formControl.parent?.parent;
      const _tmpVal = formControl.value;
      let existing = -1;
      const _tmpRepo = [];
      if (_j !== undefined && _tmpVal !== '') {
         Object.keys(_j.controls).forEach(key1 => {
            const _tmp = _j.get(key1) as FormGroup;
            const _val = _tmp.controls.value;
            if (_tmpVal === _val.value) {
               _tmpRepo.push('1');
            }
            if (_tmpRepo.length >= 2) {
               existing = 1;
            }
         });
      }
      return existing > -1 ? { valueExisting: true } : null;
   }

   checkValueItem(formControl: FormControl) {
      if (!formControl.parent?.value.maxItem && formControl.parent?.value.maxItem !== '0') {
         return null;
      }
      const checkValue = Number(formControl.parent?.value.minItem) <= Number(formControl.parent?.value.maxItem);
      if (!checkValue) {
         return { range: true };
      } else {
         return null;
      }

   }
}
